const req = require.context('./channels', true, /^(.*\.(js$))[^.]*$/im)
import defaultConfig from './channels/default'
import { channels as commonH5Channels } from './commonH5Channels'
import _ from 'lodash'

export const channels = []

Object.keys(commonH5Channels).forEach((key) => {
  channels.push(commonH5Channels[key])
})

req.keys().forEach(function(key) {
  channels.push(req(key))
})

let currentChannelCache = null

export const current = () => {
  if (currentChannelCache) { return currentChannelCache }
  let result = null
  channels.forEach((channel) => {
    if (channel.match()) {
      if (typeof channel.init === 'function' && !channel.inited) {
        channel.init()
        channel.inited = true
      }
      if (process.browser) {
        currentChannelCache = channel
      }
      result = channel
    }
  })

  if (result && process.browser) {
    // 给navbar.pug用
    window.isInH5Channel = true
  }
  return result
}

const KEYS = Object.keys(defaultConfig)

const convertKey = key => {
  return _.startCase(key)
    .split(' ')
    .join('_')
    .toUpperCase()
}

export const mixin = {
  data() {
    const data = KEYS.reduce(function(obj, key) {
      obj['CHANNEL_' + convertKey(key)] = null
      return obj
    }, {})
    return data
  },
  mounted() {
    const currentChannel = current()
    if (currentChannel) {
      KEYS.forEach(key => {
        const newKey = convertKey(key)
        let value = currentChannel[key]
        if (typeof value == 'function') {
          value = value.bind(currentChannel)
        }
        this['CHANNEL_' + newKey] = value
      })
    }
  }
}

export default {
  current,
  channels,
  mixin,
  install: function(Vue, options) {
    Vue.mixin(mixin)
  }
}



// WEBPACK FOOTER //
// ./src/mods/ChannelManager.js